export default (params) => ({
  trigger: {
    name: 'recommended_accessories.shown_alternatives',
    params: params,
  },
  config: {
    schema: {
      primary_item_id: {
        type: 'integer',
      },
      attached_item_ids: {
        pattern: '^[1-9][0-9]*(?:,[1-9][0-9]+)*$',
      },
    },
    event: {
      name: 'show_accessory_items',
      params: {
        sub_feature: 'recommended_accessories_alternative_overlay',
      },
    },
    nonInt: true,
  },
});
